import React from 'react';

export const useAuth0 = () => ({
  isAuthenticated: false,
  user: null,
  loading: false,
  loginWithRedirect: () => {},
  logout: () => {},
  getTokenSilently: () => Promise.resolve(null),
  getIdTokenClaims: () => Promise.resolve(null),
});

export const Auth0Provider = ({ children }) => React.createElement(React.Fragment, null, children);
